"use client";
import { useEffect } from "react";
import { useSearchParams, useRouter } from "next/navigation";
import LoginScreen from "@/screens/login/Login";

export default function Home() {
  const router = useRouter();
  const searchParams = useSearchParams();

  useEffect(() => {
    sessionStorage.setItem("token", "");
    sessionStorage.setItem("appId", "");
    sessionStorage.setItem("username", "");
    const agentCode = searchParams.get("agentCode");
    const agentSource = searchParams.get("source");

    sessionStorage.clear();

    if (agentCode && agentSource) {
      sessionStorage.setItem("agentCode", agentCode);
      sessionStorage.setItem("agentSource", agentSource);
      router.replace("/");
    }
  }, []);

  return <LoginScreen />;
}
